export default function About() {
  return (
    <>
      <section id="about">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="wow bounceIn"
                data-wow-offset="50"
                data-wow-delay="0.3s"
              >
                I'm<span>Engineer</span>
              </h2>
            </div>
            <h4>
              Hello World! I am Software Developer Specialized in JavaScript,
              TypeScript and React. having a more than one year of professional
              experience. I have completed my <a href="">B.Tech</a> from{" "}
              <a href="http://www.kanpuruniversity.org/" target="_blank">
                Kanpur University
              </a>
              , specialized in{" "}
              <a href="https://en.wikipedia.org/wiki/Computer_science_and_engineering">
                Computer Science And Engineering
              </a>
              . Currently, I am working as
              <a href="https://en.wikipedia.org/wiki/Programmer">
                Software Developer
              </a>
              .
            </h4>
            {/*<div class="col-md-4 col-sm-4 col-xs-12 wow fadeInLeft" data-wow-offset="50" data-wow-delay="0.6s">
						<div class="media">
							<div class="media-heading-wrapper">
								<div class="media-object pull-left">
									<FaMobile />
								</div>
								<h3 class="media-heading">FULLY RESPONSIVE</h3>
							</div>
							<div class="media-body">
								<p>Awesome responsive template is provided by <a rel="nofollow" href="http://www.templatemo.com" target="_parent">templatemo</a> website. This is Bootstrap v3.3.2 layout built on HTML5 CSS3. You can use this for any purpose. Please tell your friends about it.</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-offset="50" data-wow-delay="0.9s">
						<div class="media">
							<div class="media-heading-wrapper">
								<div class="media-object pull-left">
									<i class="fa fa-comment-o"></i>
								</div>
								<h3 class="media-heading">FREE SUPPORT</h3>
							</div>
							<div class="media-body">
								<p>Credits go to <a rel="nofollow" href="http://pixabay.com">Pixabay</a> for homepage image and <a rel="nofollow" href="http://unsplash.com">Unsplash</a> for portfolio images. Lorem ipsum dolor sit amet, consectetur adipiscing elitquisque tempus ac eget diam et laoreet phasellus ut nisi id leo molestie.</p>
							</div>
						</div>
					</div>
					<div class="col-md-4 col-sm-4 col-xs-12 wow fadeInRight" data-wow-offset="50" data-wow-delay="0.6s">
						<div class="media">
							<div class="media-heading-wrapper">
								<div class="media-object pull-left">
									<i class="fa fa-html5"></i>
								</div>
								<h3 class="media-heading">HTML5 &AMP; CSS3</h3>
							</div>
							<div class="media-body">
								<p>Lorem ipsum dolor sit amet, consectetur adipiscing elitquisque tempus ac eget diam et laoreet phasellus ut nisi id leo molestie. Adipiscing vitae vel quam proin eget mauris eget. Lorem ipsum dolor sit amet.</p>
							</div>
						</div>
  </div> */}
          </div>
        </div>
      </section>
    </>
  );
}
